import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {PresentsHttpService} from '../../../../../services/http-services/presents/presents-http.service';
import {BankAccountRegex, EmailRegex, MobileRegex} from '../../../../../constants/general-variables';

@Component({
  selector: 'gr-tab-present-profile',
  templateUrl: './tab-present-profile.component.html',
})
export class TabPresentProfileComponent implements OnInit {
  formTriedToSubmit = false;
  editPresentProfileForm!: FormGroup;
  imageUrls: any[] = [];
  deletedImagesIds: number[] = [];
  isPresentProfileFormDisabled = true;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  constructor(private formBuilder: FormBuilder,
              private toastService: ToastrService,
              private presentsHttpService: PresentsHttpService) {
  }
  ngOnInit(): void {
    this.buildForm();
  }
  buildForm(): void {
    this.editPresentProfileForm = this.formBuilder.group({
      name: ['', Validators.required],
      phone: ['', [Validators.required, Validators.pattern(MobileRegex)]],
      email: ['', [Validators.required, Validators.pattern(EmailRegex)]],
      bank_account_number: ['', [Validators.required, Validators.pattern(BankAccountRegex)]],
      images: [null, Validators.required],
      deleted_images_ids: [[]],
      promo_codes: this.formBuilder.array([])
    });
    this.getPresentProfile();
  }

  enablePresentProfileForm(): void {
    this.isPresentProfileFormDisabled = false;
    this.editPresentProfileForm.enable();
  }

  disabledPresentProfileForm(): void {
    this.isPresentProfileFormDisabled = true;
    this.editPresentProfileForm.disable();
  }

  getPresentProfile(): void {
    this.presentsHttpService.getPresentProfile({ profileId: 1 }).then(res => {
      console.log(res.data);

      // 1) Upis osnovnih vrednosti u formu
      this.editPresentProfileForm.patchValue(res.data);

      // 2) Reset FormArray
      this.promoCodes.clear();

      // 3) Učitaj promo kodove iz res.data.promo_codes
      const promoCodes = res.data.promo_codes || [];

      if (promoCodes.length > 0) {
        promoCodes.forEach((pc: any) => this.addPromoCode(pc));
      } else {
        // ako želiš odmah jedan prazan red:
        // this.addPromoCode();
      }

      // 4) Obrada slika
      if (!res.data.images?.length) {
        this.editPresentProfileForm.controls.images.patchValue(null);
      } else {
        this.imageUrls = res.data.images.map((item: any) => ({
          fullPath: item.full_path,
          id: item.id,
          file: undefined
        }));
      }
      this.disabledPresentProfileForm();

    });
  }

  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      const selectedFiles = Array.from(input.files);
      if (selectedFiles.length > 10 - this.imageUrls.length) {
        this.toastService.warning('Neke od slika nece biti uploadovane zato sto ste selektovali vise slika od broja slobodnih slotova, maksimalno mozete dodati 10 slika');
      }
      selectedFiles.forEach(file => {
        if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/jpg' && file.type !== 'image/svg') {
          this.toastService.warning('Pogrešan tip dokumenta. Samo JPG, JPEG, SVG i PNG formati su dozvoljeni.');
          return;
        } else if (file?.size > 10485760) {
          this.toastService.warning(`Slika ${file.name} je veća od 10MB.`);
          return;
        } else if (this.imageUrls.length < 10) {
          this.imageUrls.push({fullPath: URL.createObjectURL(file), id: undefined, file});
        }
      });
      this.editPresentProfileForm.controls.images.patchValue(this.imageUrls);
      if (this.fileInput) {
        this.fileInput.nativeElement.value = '';
      }
    }
  }

  removeAllImages(): void {
    this.imageUrls.forEach((image: any) => {
      if (image.id) {
        this.deletedImagesIds.push(image.id);
      }
    });
    this.imageUrls = [];
    this.editPresentProfileForm.controls.deleted_images_ids.patchValue(this.deletedImagesIds);
    this.editPresentProfileForm.controls.images.patchValue(null);
  }

  removeSingleImage(imageURL: any): void {
    if (!this.isPresentProfileFormDisabled){
      const imageIndex = this.imageUrls.findIndex((imgUrl: any) => {
        return imgUrl.fullPath === imageURL.fullPath;
      });
      if (imageIndex !== -1) {
        if (imageURL.id) {
          this.deletedImagesIds.push(imageURL.id);
        }
        this.imageUrls.splice(imageIndex, 1);
        this.editPresentProfileForm.controls.deleted_images_ids.patchValue(this.deletedImagesIds);
        this.editPresentProfileForm.controls.images.patchValue(this.imageUrls.length ? this.imageUrls : null);
      }
    }
  }

  onSubmitPresentProfileForm(): void {
    this.formTriedToSubmit = true;
    if (this.editPresentProfileForm.valid) {
      const formData: FormData = new FormData();
      for (const key in this.editPresentProfileForm.value) {
        if (Array.isArray(this.editPresentProfileForm.value[key]) ) {
          if (key === 'images') {
            this.editPresentProfileForm.value[key].forEach((element: any, index: number) => {
              formData.append(`images[${index}][position]`, (index + 1).toString());
              (element.id)
                ? formData.append(`images[${index}][id]`, element.id.toString())
                : formData.append(`images[${index}][file]`, element.file);
            });
          } else if (key === 'promo_codes') {
            this.editPresentProfileForm.value.promo_codes.forEach((pc: any, index: number) => {
              if (pc.id) {
                formData.append(`promo_codes[${index}][id]`, pc.id);
              }
              formData.append(`promo_codes[${index}][code]`, pc.code);
              formData.append(`promo_codes[${index}][discount]`, pc.discount);
              formData.append(`promo_codes[${index}][status]`, pc.status ? '1' : '0');
            });
            continue;
          }  else {
            this.editPresentProfileForm.value[key].forEach((element: any) => {
              formData.append(`${key}[]`, element);
            });
          }
        } else {
          formData.append(key, this.editPresentProfileForm.value[key]);
        }
      }
      this.presentsHttpService.putPresentProfile({profileId: 1}, formData).then((res: any) => {
        this.toastService.success('Uspešno ste izmenili podatke profila.');
        this.formTriedToSubmit = false;
        this.disabledPresentProfileForm();
      });
    }
  }

  get promoCodes(): FormArray {
    return this.editPresentProfileForm.get('promo_codes') as FormArray;
  }

  addPromoCode(existing?: any) {
    this.promoCodes.push(
      this.formBuilder.group({
        id: [existing?.id || null],
        code: [
          existing?.code || '',
          [Validators.required, Validators.minLength(4)]
        ],
        discount: [
          existing?.discount || '',
          [
            Validators.required,
            Validators.min(1),
            Validators.max(100)
          ]
        ],
        status: [existing?.status || false]
      })
    );
  }

  removePromoCode(index: number) {
    this.promoCodes.removeAt(index);
  }
}
